import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Location';

const routes = [
    {
        matchRegex: '/Location/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'stock-table', label: 'Stock Table' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS',
                    label: 'Trigger Fetch List Successfully',
                },
            ],
        },
    },
]

export default routes;